import { render, staticRenderFns } from "./itemUpload.vue?vue&type=template&id=5160e807&scoped=true"
import script from "./itemUpload.vue?vue&type=script&lang=js"
export * from "./itemUpload.vue?vue&type=script&lang=js"
import style0 from "./itemUpload.vue?vue&type=style&index=0&id=5160e807&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160e807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5160e807')) {
      api.createRecord('5160e807', component.options)
    } else {
      api.reload('5160e807', component.options)
    }
    module.hot.accept("./itemUpload.vue?vue&type=template&id=5160e807&scoped=true", function () {
      api.rerender('5160e807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file/itemUpload.vue"
export default component.exports